import { getClient } from '@lib/sanity'
import { loadTranslation } from '@lib/i18n'
import { groq } from 'next-sanity'
import PostsIndex from 'components/PostsIndex'

const POSTS_PER_PAGE = 12
const postTypes = ['publications', 'news', 'events', 'blog', 'press', 'media']

export const getStaticPaths = async ({ locales }) => {
  const pagePaths = []
  /*
  const queries = postTypes.map((postType) =>
    locales.map(
      (locale) =>
        `"${postType}_${locale}": count(*[_type == "post" && type == "${postType}" && locale == "${locale}" && dateTime(publishedAt) <= dateTime(now())])`
    )
  )
  const totals = await getClient().fetch(groq`{
    ${queries.join(',\n')}
  }`)*/
  postTypes.map((postType) => {
    locales.forEach((locale) => {
      /*
      if (totals[`${postType}_${locale}`]) {
        const pages = Math.max(
          Math.ceil(parseInt(totals[`${postType}_${locale}`]) / POSTS_PER_PAGE),
          2
        )
        for (let i = 1; i <= pages; i++) {
          pagePaths.push({
            params: {
              type: postType,
              page: [String(i)],
              locale,
            },
          })
        }
      } else {*/
      pagePaths.push({
        params: {
          type: postType,
          page: ['1'],
          locale,
        },
      })
      /*}*/
    })
  })
  return { paths: pagePaths, fallback: 'blocking' }
}

export const getStaticProps = async ({ locale, params, preview = false }) => {
  // page = [page, variant, year, month]
  const { type = 'news', page = ['1'] } = params
  let variant = ''
  let year = null
  let month = null

  const start =
    page[0] === '1' ? 0 : parseInt(page[0]) * POSTS_PER_PAGE - POSTS_PER_PAGE
  const end = start + POSTS_PER_PAGE
  if (
    page[1] &&
    (page[1] === 'past' || page[1] === 'idpc' || page[1] === 'members')
  ) {
    variant = page[1]
  }
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV === 'production'
  )

  let dateField = 'publishedAt'
  let dateFieldStartValue = null
  let dateFieldEndValue = null

  if (type === 'events') {
    dateField = 'eventStart'
    if (variant !== 'past') {
      dateFieldStartValue = new Date()
    } else {
      dateFieldEndValue = new Date()
    }
  }

  if (parseInt(page[2])) {
    dateFieldStartValue = false
    dateFieldEndValue = false

    year = page[2]
    if (parseInt(page[3])) {
      month = page[3]
    }

    dateFieldStartValue = new Date()
    dateFieldEndValue = new Date()
    if (year && month) {
      dateFieldStartValue = new Date(`${year}-${month}-01`)
      dateFieldEndValue = new Date(dateFieldStartValue)
      dateFieldEndValue = new Date(
        dateFieldEndValue.setMonth(dateFieldEndValue.getMonth() + 1)
      )
    } else if (year) {
      dateFieldStartValue = new Date(`${year}-01-01`)
      dateFieldEndValue = new Date(`${year}-12-31`)
    }
  }

  let query = groq`{
    "posts": *[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now())] | order(${dateField} desc)[$start...$end]{_id, title, _type, type, mainImage, body, excerpt, publishedAt, eventStart, eventEnd, eventLocation, slug, source},
    "totalPosts": count(*[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now())])
  }`

  if (dateFieldStartValue && dateFieldEndValue) {
    query = groq`{
      "posts": *[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && dateTime(${dateField}) >= dateTime("${dateFieldStartValue.toISOString()}") && dateTime(${dateField}) < dateTime("${dateFieldEndValue.toISOString()}")] | order(${dateField} asc)[$start...$end]{_id, title, _type, type, mainImage, excerpt, body, publishedAt, eventStart, eventEnd, eventLocation, slug, source},
      "totalPosts": count(*[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && dateTime(${dateField}) >= dateTime("${dateFieldStartValue.toISOString()}") && dateTime(${dateField}) < dateTime("${dateFieldEndValue.toISOString()}")])
    }`
  } else if (dateFieldStartValue) {
    // Used for upcoming events (order asc)
    query = groq`{
      "posts": *[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && dateTime(${dateField}) >= dateTime("${dateFieldStartValue.toISOString()}")] | order(${dateField} asc)[$start...$end]{_id, title, _type, type, mainImage, excerpt, body, publishedAt, eventStart, eventEnd, eventLocation, slug, source},
      "totalPosts": count(*[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && dateTime(${dateField}) >= dateTime("${dateFieldStartValue.toISOString()}")])
    }`
  } else if (dateFieldEndValue) {
    // Used for past events (order desc)
    query = groq`{
      "posts": *[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && dateTime(${dateField}) < dateTime("${dateFieldEndValue.toISOString()}")] | order(${dateField} desc)[$start...$end]{_id, title, _type, type, mainImage, excerpt, body, publishedAt, eventStart, eventEnd, eventLocation, slug, source},
      "totalPosts": count(*[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && dateTime(${dateField}) < dateTime("${dateFieldEndValue.toISOString()}")])
    }`
  } else if (variant === 'idpc') {
    query = groq`{
      "posts": *[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && ("organisation_international-drug-policy-consortium-idpc" in relatedProfiles[]._ref || "organisation_international-drug-policy-consortium-idpc" in authors[]._ref)] | order(publishedAt desc)[$start...$end]{_id, title, _type, type, mainImage, excerpt, body, publishedAt, eventStart, eventEnd, eventLocation, slug, source},
      "totalPosts": count(*[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && ("organisation_international-drug-policy-consortium-idpc" in relatedProfiles[]._ref || "organisation_international-drug-policy-consortium-idpc" in authors[]._ref)])
    }`
  } else if (variant === 'members') {
    query = groq`{
      "posts": *[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && references(*[_type == "member"]._id)] | order(publishedAt desc)[$start...$end]{_id, title, _type, type, mainImage, excerpt, body, publishedAt, eventStart, eventEnd, eventLocation, slug, source},
      "totalPosts": count(*[_type == "post" && type == $type && locale == $locale && dateTime(publishedAt) <= dateTime(now()) && references(*[_type == "member"]._id)])
    }`
  }

  const posts = await getClient(preview).fetch(query, {
    type,
    locale,
    start,
    end,
    dateField,
    dateFieldStartValue,
    dateFieldEndValue,
  })

  if (!posts.posts) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      translation,
      type,
      variant,
      year,
      month,
      page: page[0],
      totalPages: Math.ceil(posts.totalPosts / POSTS_PER_PAGE),
      start,
      end,
      posts: posts.posts,
      totalPosts: posts.totalPosts,
      preview,
    },
    revalidate: 60 * 5, // Every five mins
  }
}

export default PostsIndex
